<template>
	<div class="header">
		<div class="container-fluid">
			<!-- Hearer  -->
			<div class="mt-4">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">Master Data</li>
								<li class="breadcrumb-item">Users</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<!-- Card  -->
			<div class="card mt-5">
				<div class="card-header">
					<!-- Title -->
					<h4 class="card-header-title">Users</h4>
					<!-- Button -->
					<b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true" v-if="canAdd">
						<span class="fe fe-plus-circle"></span>
						Add User
					</b-button>
					<b-button v-b-toggle.collapse-1 variant="primary" style="margin-left: 7px">
						<span class="fe fe-filter"></span>
					</b-button>
				</div>
				<b-collapse id="collapse-1" visible>
					<div class="row row-cols-1 row-cols-md-3 p-4">
						<div class="col">
							<div class="form-group">
								<label class="form-label">Filter Role</label>
								<v-select
									v-model="body.roles_id"
									:options="listRole.data"
									label="roles_name"
									:reduce="(e) => e.id"
									name="role_id"
									@input="filterData"
								/>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label class="form-label">Filter Department</label>
								<v-select
									v-model="body.department_id"
									:options="listDepartment"
									label="name"
									:reduce="(e) => e.id"
									name="Department"
									@input="filterData"
								>
									<template v-slot:option="option">
										<span>{{ `${option.code} - ${option.name}` }}</span>
									</template>
								</v-select>
							</div>
						</div>
						<div class="col">
							<label class="form-label">Search Name or Email</label>
							<b-form-input v-model="body.search" class="w-full" placeholder="Type Here..." @input="filterData">
							</b-form-input>
						</div>
					</div>
				</b-collapse>
				<div class="text-center">
					<div class="spinner-border" role="status" v-show="isLoading == true">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
				<div class="overflow-auto" v-show="isLoading == false">
					<vue-good-table
						ref="usersTable"
						:line-numbers="true"
						:columns="columns"
						:rows="list.data"
						:sort-options="{
							enabled: true,
						}"
						:total-rows="list.totalItems"
						:pagination-options="{
							enabled: true,
							mode: 'pages',
							position: 'bottom',
							perPage: this.body.limit || 10,
							perPageDropdown: [10, 50, 100],
							dropdownAllowAll: false,
							setCurrentPage: this.body.page,
							nextLabel: 'next',
							prevLabel: 'prev',
							rowsPerPageLabel: 'Rows per page',
							ofLabel: 'of',
							pageLabel: 'page',
							allLabel: 'All',
						}"
						style-class="vgt-table border-0 table"
						@on-page-change="onPageChange"
						@on-per-page-change="onPageChange"
						@on-sort-change="onSortChange"
					>
						<!-- Loading -->
						<div slot="emptystate" class="text-center font-size-14">No data available</div>
						<!-- Custom Rows -->
						<template slot="table-row" slot-scope="props">
							<!-- Table Action -->
							<span v-if="props.column.field == 'email'">
								<span
									:id="'tooltip-email-' + props.row.id"
									class="contract-name-cell"
									style="max-width: 350px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
								>
									{{ props.row.email }}
								</span>
								<b-tooltip
									:target="'tooltip-email-' + props.row.id"
									placement="right"
									triggers="hover"
									variant="dark"
									custom-class="custom-tooltip"
								>
									{{ props.row.email }}
								</b-tooltip>
							</span>
							<span v-else-if="props.column.label == 'Division'">
								<span
									:id="'tooltip-divisi-' + props.row.id"
									class="contract-name-cell"
									style="max-width: 200px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
								>
									{{ props.row.divisi }}
								</span>
								<b-tooltip
									:target="'tooltip-divisi-' + props.row.id"
									placement="left"
									triggers="hover"
									variant="dark"
									custom-class="custom-tooltip"
								>
									{{ props.row.divisi }}
								</b-tooltip>
							</span>
							<span v-else-if="props.column.label == 'Departments'">
								<span
									:id="'tooltip-department-' + props.row.id"
									class="contract-name-cell"
									style="max-width: 200px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
								>
									{{
										props.row.departments
											.map((department) => {
												return department.name;
											})
											.join(', ')
									}}
								</span>
								<b-tooltip
									:target="'tooltip-department-' + props.row.id"
									placement="left"
									triggers="hover"
									variant="dark"
									custom-class="custom-tooltip"
								>
									{{
										props.row.departments
											.map((department) => {
												return department.name;
											})
											.join(', ')
									}}
								</b-tooltip>
							</span>
							<span v-else-if="props.column.field == 'action' && (canEdit || canDelete)">
								<b-dropdown id="dropdown-1" dropleft variant="primary" overflow="scroll" size="sm" class="m-md-2">
									<b-dropdown-item class="dropdown-item-custom" @click="updateData(props.row)" v-if="canEdit">
										Edit
									</b-dropdown-item>
									<b-dropdown-item class="dropdown-item-custom" @click="deleteData(props.row.id)" v-if="canDelete">
										Delete
									</b-dropdown-item>
								</b-dropdown>
							</span>
						</template>
					</vue-good-table>
				</div>
			</div>

			<!-- Modal -->
			<b-modal id="modal-1" hide-footer :title="`${isAdd ? 'Add' : 'Update'} User`" @hide="closeNotification($event)">
				<form @submit.prevent="save()">
					<div class="form-group">
						<label>Name <span class="text-danger">*</span></label>
						<input
							type="text"
							class="form-control"
							placeholder="Employee Name"
							v-model="user.fullname"
							v-validate="'required'"
							name="name"
						/>
						<span class="text-sm text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
					</div>
					<div class="form-group">
						<label>Email <span class="text-danger">*</span></label>
						<input
							type="text"
							class="form-control"
							placeholder="Email"
							v-model="user.email"
							v-validate="'required|email'"
							name="email"
						/>
						<span class="text-sm text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</span>
					</div>
					<div class="form-group">
						<label>Phone Number <span class="text-danger">*</span></label>
						<input
							type="text"
							class="form-control"
							placeholder="Phone number"
							v-model="user.phone"
							v-validate="'required'"
							name="phone"
							@input="formatPhoneNumber(user.phone)"
						/>
						<span class="text-sm text-danger" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
					</div>
					<div class="form-group">
						<label>Role <span class="text-danger">*</span></label>
						<v-select
							v-model="user.role_id"
							:options="listRole.data"
							label="roles_name"
							placeholder="Select Role"
							:reduce="(e) => e.id"
							v-validate="'required'"
							name="Role"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Role')">{{ errors.first('Role') }}</span>
					</div>
					<div class="form-group">
						<label>Department</label>
						<v-select
							v-model="user.department_ids"
							:options="listDepartment"
							label="name"
							multiple
							placeholder="Select Division / Department"
							:reduce="(e) => e.id"
							name="Department"
							v-validate="isSuperAdmin ? '' : 'required'"
						>
							<template v-slot:option="option">
								<span>{{ `${option.code} - ${option.name}` }}</span>
							</template>
						</v-select>
						<span class="text-sm text-danger" v-show="errors.has('Department')">{{ errors.first('Department') }}</span>
					</div>
					<div class="form-group float-end">
						<button class="mt-4 btn btn-outline-light mr-2" type="button" @click="confirmAndCloseModal()">Cancel</button>
						<button class="mt-4 btn btn-primary" type="submit" v-if="isLoading == false">Save</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</form>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import { authorize } from '@/utils/authorize';
	import { onlyNumber } from '@/utils/common';
	import { debounce } from 'lodash';

	export default {
		name: 'listContract',
		computed: {
			list() {
				return this.$store.getters['users/list'];
			},
			listRole() {
				return this.$store.getters['role/list'];
			},
			listDepartment() {
				return this.$store.getters['organization/departments'] || [];
			},
		},
		data() {
			return {
				body: {
					page: 1,
					limit: 10,
					search: '',
					roles_id: '',
					department_id: '',
					order: '',
				},
				isAdd: true,
				isLoading: false,
				columns: [
					{
						label: 'Name',
						field: 'fullname',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: true,
					},
					{
						label: 'Email',
						field: 'email',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: true,
					},
					{
						label: 'Role',
						field: (row) => `${row.roles[0]?.roles_name ?? ''}`,
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
					{
						label: 'Departments',
						field: 'departments',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				user: {
					id: null,
					fullname: '',
					email: '',
					phone: '',
					role_id: null,
					department_ids: [],
				},
				canAdd: false,
				canEdit: false,
				canDelete: false,
				isSuperAdmin: false,
			};
		},

		async mounted() {
			await this.getList();
			await this.getRole();
			await this.getDepartments();
			this.canAdd = await authorize('/users', 'create');
			this.canEdit = await authorize('/users', 'update');
			this.canDelete = await authorize('/users', 'delete');
			this.debounceSearch = debounce(this.getList, 500);
		},
		watch: {
			'user.role_id': {
				//if not super admin then department must not empty
				handler: function () {
					const superAdmin = this.listRole.data.find((role) => role.roles_name.toLowerCase() === 'super admin');
					this.isSuperAdmin = superAdmin?.id === this.user.role_id;
				},
			},
		},
		methods: {
			//action
			async updateData(props) {
				this.isAdd = false;
				this.user = {
					id: props.id,
					fullname: props.fullname,
					email: props.email,
					phone: props.phone,
					role_id: props.roles[0]?.id,
					department_ids: props.departments.map((department) => department.id) || [0],
				};
				this.$bvModal.show('modal-1');
			},

			reset() {
				this.user = {
					id: null,
					fullname: '',
					email: '',
					phone: '',
					role_id: null,
					department_ids: [],
				};
				this.isAdd = true;
			},

			closeNotification(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.confirmAndCloseModal();
				}
			},

			confirmAndCloseModal() {
				this.$swal({
					title: 'Confirm Close?',
					text: 'Are you sure you want to close this page?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$bvModal.hide('modal-1');
						this.reset();
					} else {
						console.log('Modal close cancelled from button.');
					}
				});
			},

			async getList() {
				this.isLoading = true;
				await this.$store
					.dispatch('users/GET_LIST', this.body)
					.then(() => {
						this.isLoading = false;
					})
					.catch(() => {
						this.isLoading = false;
						this.$swal('Error', 'Error while get data', 'error');
					});
			},
			async getRole() {
				await this.$store.dispatch('role/GET_LIST');
			},
			async getDepartments() {
				await this.$store.dispatch('organization/GET_LIST', { limit: 1000, page: 1, search: '' });
			},

			async save() {
				this.$validator.validateAll().then(async (res) => {
					if (!res) return false;
					try {
						this.isLoading = true;
						if (this.isAdd) {
							await this.$store.dispatch('users/CREATE_DATA', this.user).then(() => {
								this.$swal('Saved', 'Your input has been saved', 'success').then(async () => {
									await this.getList();
								});
							});
						} else {
							await this.$store.dispatch('users/UPDATE_DATA', this.user).then(() => {
								this.$swal('Saved', 'Your input has been updated', 'success').then(async () => {
									await this.getList();
								});
							});
						}
						this.isAdd = true;
						this.isLoading = false;
						this.$bvModal.hide('modal-1');
						this.reset();
					} catch (error) {
						if (error?.response?.data?.error) {
							this.$swal('Error', error?.response?.data?.error, 'error');
						} else {
							this.$swal('Error', 'Error while add data', 'error');
						}
						this.isLoading = false;
					}
				});
			},

			deleteData(id) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$store
							.dispatch('users/DELETE_DATA', id)
							.then(() => {
								this.getList();
								this.$swal('Deleted!', 'Your data has been deleted', 'success');
							})
							.catch(() => {
								this.$swal('Error', 'Error while delete data', 'error');
							});
					}
				});
			},
			onSortChange(payload) {
				//handle current page sort only
				this.$nextTick(() => {
					if (this.$refs.usersTable) {
						this.$refs.usersTable.changePage(this.body.page);
					}
				});
			},
			// Pagination
			onPageChange(payload) {
				this.body.limit = payload.currentPerPage;
				this.body.page = payload.currentPage;
				this.getList();
			},
			filterData() {
				this.body.page = 1;
				this.debounceSearch();
			},

			formatPhoneNumber(number) {
				number = onlyNumber(number);
				this.user.phone = number;
			},
		},
	};
</script>
<style>
	.vgt-inner-wrap {
		min-width: 100% !important;
	}
	.custom-tooltip .tooltip-inner {
		white-space: nowrap !important;
		max-width: none !important;
		width: auto !important;
		min-width: fit-content !important;
		overflow: visible !important;
		text-overflow: clip !important;
	}
</style>
